module.exports = __webpack_public_path__ + "static/img/11.81f35d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/11.png
// module id = RKxq
// module chunks = 0